(function () {
  angular.module("akitabox.core.ui.dialogs.workOrder.create.locationSection", [
    "akitabox.core.services.organization",
    "akitabox.core.services.room",
  ]);
})();
